import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./zenta-image-picker.css";
import { CustomImage } from "burde";

interface ZentaImagePickerProps {
    selectedImage?: string | null;
    onClick: (selectedImage: string | null) => void;
    defaultRoute: string | null;
    images: Array<string>;
    forceFitImage?: boolean;
    resizeImage?: boolean;
    removeMarginBottom?: boolean;
    onRemove: ((selectedImage: string) => void) | null;
    selectedImages: CustomImage[] | null;
}

const ZentaImagePicker: React.FC<ZentaImagePickerProps> = ({
    selectedImage,
    onClick,
    defaultRoute,
    images,
    forceFitImage = false,
    resizeImage = true,
    removeMarginBottom = false,
    onRemove,
    selectedImages,
}) => {
    const cx = cn.bind(styles);

    const ulCn = () =>
        cx({
            imagePickerUl: true,
            noBottomMargin: removeMarginBottom,
        });

    const liCn = () =>
        cx({
            imagePickerLi: true,
        });

    const imageCn = (isSelected: boolean) =>
        cx({
            imageItem: true,
            imageItemCover: false,
            imageItemSelected: isSelected,
            forceFitImage: forceFitImage,
            noBottomMargin: removeMarginBottom,
        });

    const removeCn = () =>
        cx({
            removeImage: true,
        });

    const imageUrlIsSelected = (imageUrl: string) => {
        if (!selectedImages) {
            return false;
        }

        if (imageUrl === selectedImage) {
            return true;
        }

        const found = selectedImages.find((x) => x.url === imageUrl);

        if (found) {
            return true;
        }

        return false;
    };

    return (
        <ul className={ulCn()}>
            {images.map((imageUrl) => (
                <li key={imageUrl} className={liCn()}>
                    {onRemove && !imageUrlIsSelected(imageUrl) && (
                        <div
                            className={removeCn()}
                            onClick={() => onRemove(imageUrl)}>
                            <i className="fas fa-times"></i>
                        </div>
                    )}
                    <div
                        className={imageCn(imageUrl === selectedImage)}
                        style={{
                            backgroundImage: `url(${
                                defaultRoute +
                                imageUrl +
                                (resizeImage ? "?width=70&height=70" : "")
                            })`,
                        }}
                        onClick={() =>
                            onClick(
                                imageUrl === selectedImage ? null : imageUrl,
                            )
                        }
                    />
                </li>
            ))}
        </ul>
    );
};

export default ZentaImagePicker;
